import { render, staticRenderFns } from "./LegacyData.vue?vue&type=template&id=725b2f91&"
import script from "./LegacyData.vue?vue&type=script&lang=js&"
export * from "./LegacyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports